import { useMemo } from "react";

import {
  generateFormSchemaForParameters,
  generateFormTemplateForParameters,
  generateInputFieldForParameters,
  // processPromptForAttributes,
  getTestCallVariables,
} from "./utils";

import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";

import { Button } from "V2.0/common/button";
import Drawer from "V2.0/components/DrawerV2";

const AttributesAction = (props) => {
  const { onCancel, isUpdateDisabled, onUpdate } = props;
  return (
    <>
      <Button
        outline
        onClick={onCancel}
      >
        Cancel
      </Button>
      <Button
        disabled={isUpdateDisabled}
        onClick={onUpdate}
      >
        Update
      </Button>
    </>
  );
};

const ViewMessageAction = (props) => {
  const { onClose } = props;
  return (
    <Button
      outline
      onClick={onClose}
    >
      Close
    </Button>
  );
};

export default function CustomAttributesAdd(props) {
  // const { parametersInitialValues, template, onUpdateParameters, onClose } =
  //   props;
  const {
    parametersInitialValues,
    template,
    callType,
    onUpdateParameters,
    onClose,
  } = props;

  // const parameters = useMemo(() => {
  //   return processPromptForAttributes(template);
  // }, [template]);
  const parameters = useMemo(() => {
    return getTestCallVariables(template, callType);
  }, [template, callType]);

  const fieldsTemplate = useMemo(
    () => generateFormTemplateForParameters(parameters),
    [parameters]
  );

  const schema = useMemo(
    () => generateFormSchemaForParameters(parameters),
    [parameters]
  );

  const inputField = useMemo(() => {
    if (Boolean(Object.keys(parametersInitialValues).length)) {
      return parametersInitialValues;
    }

    return generateInputFieldForParameters(parameters);
  }, [parameters, parametersInitialValues]);

  const { data, handleChange, validate, error } = useForm(inputField, schema);

  function handleUpdate() {
    onUpdateParameters(data);
    onClose();
  }

  const isUpdateDisabled =
    validate(data, schema) || Boolean(Object.keys(error).length);

  const title = parameters?.length === 0 ? "View Message" : "Update Variables";

  return (
    <Drawer
      open={true}
      title={title}
      onClose={onClose}
    >
      <div className="flex flex-col h-full flex-shrink-0 pt-4">
        <div className="flex-1 overflow-scroll min-h-0 h-full px-4">
          <Form
            data={data}
            handleChange={handleChange}
            error={error}
            template={fieldsTemplate}
            className="gap-y-4"
          />
        </div>
        <div className="flex-shrink-0 px-4 py-4 flex border-t items-center gap-x-2 justify-end w-full">
          {parameters.length === 0 ? (
            <ViewMessageAction onClose={onClose} />
          ) : (
            <AttributesAction
              onCancel={onClose}
              onUpdate={handleUpdate}
              isUpdateDisabled={isUpdateDisabled}
            />
          )}
        </div>
      </div>
    </Drawer>
  );
}